


import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import '../css/navbar.css'; // Assurez-vous d'importer le fichier CSS

const Navbar = () => {
  const [showNav, setShowNav] = useState(false);
  const { i18n, t } = useTranslation();
  const location = useLocation();

  const toggleNav = () => setShowNav((prev) => !prev);
  const toggleLanguage = () => i18n.changeLanguage(i18n.language === "en" ? "fr" : "en");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".navbar-container")) {
        setShowNav(false);
      }
    };

    if (showNav) {
      document.addEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [showNav]);

  useEffect(() => {
    setShowNav(false); // Ferme le menu après changement de page
  }, [location.pathname]);

  return (
    <div className="navbar-container">
      {/* Logo et texte */}
      <div className="navbar-logo">
        <a href="/" className="flex items-center">
          <img src="/images/2.png" alt="logo" className="logo-img" />
        </a>
        <span className="logo-text">Crafting Tomorrow's Solutions, Today</span>
      </div>

      {/* Bouton Burger pour mobile */}
      <button className="navbar-toggle" onClick={toggleNav}>
        ☰
      </button>

      {/* Liens de navigation */}
      <div className={`navbar-links ${showNav ? 'show' : ''}`}>
        {[
          { path: "/home", label: t("home") },
          { path: "/audit-cloud", label: t("nav_audit"), offer: true },
          { path: "/agences", label: t("nav_agencies"), offer: true },
          { path: "/services", label: "Services" },
          { path: "/about", label: t("navbar_about_us") },
          { path: "/contactUs", label: t("navbar_contact_us") },
        ].map(({ path, label, offer }) => (
          <div key={path} className="navbar-item">
            <Link
              to={path}
              className={`navbar-link ${offer ? "offer" : ""} ${
                location.pathname === path ? "active" : ""
              }`}
              onClick={() => setShowNav(false)} // Fermer le menu après le clic
            >
              {label}
            </Link>
          </div>
        ))}

        {/* Bouton Langue */}
        <div className="navbar-item">
          <button className="language-btn" onClick={toggleLanguage}>
            {i18n.language === "en" ? "🇫🇷 FR" : "🇬🇧 EN"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
